export default "__VITE_ASSET__Cpu$YpOz__"